import { render, staticRenderFns } from "./PopupTriggerShare.vue?vue&type=template&id=0324e6a8&scoped=true"
import script from "./PopupTriggerShare.vue?vue&type=script&lang=js"
export * from "./PopupTriggerShare.vue?vue&type=script&lang=js"
import style0 from "./PopupTriggerShare.vue?vue&type=style&index=0&id=0324e6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0324e6a8",
  null
  
)

export default component.exports